module.exports = __webpack_public_path__ + "img/Wp_2056.40137326.png";